import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'cbCallback',
    pure: false,
    standalone: false
})
export class CbCallbackPipe implements PipeTransform {
    public transform(items: any[], callback: (item: any) => boolean): any {
        if (!items || !callback) {
            return items;
        }
        return items.filter(item => callback(item));
    }
}
